import React, { Component } from 'react';
import { Field, reduxForm } from 'redux-form';

import FormGlobalErrors from '../../Form/FormGlobalErrors.jsx';
import Select from '../../Form/Field/Select.jsx';
import Loader from '../../../../shared/components/Loader/Loader.jsx';

import validate from './validate';
import conf from "../../../conf.js";

export const name = 'OfferAnswerDenialForm';

class OfferAnswerDenialForm extends Component {
  render() {
    return (
      <div id={name}>
        <form autoComplete="off" onSubmit={this.props.handleSubmit}>
          <div className="row">
            <div className="col-12">
              <Field
                label="Raison du refus de la candidature"
                name="denial_motive"
                type="text"
                component={Select}
              >
                {Object.keys(conf.offerAnswerDenials).map((key) => (
                  <option value={key} key={key}>{conf.offerAnswerDenials[key]}</option>
                ))}
              </Field>
            </div>
          </div>
          <input className="d-none" type="submit" />
          <FormGlobalErrors className="mt-0" errors={this.props.error} />
        </form>
        <Loader visible={this.props.submitting || this.props.triggerSubmit} />
      </div>
    );
  }
}

export default reduxForm({
  form: name,
  validate,
})(OfferAnswerDenialForm);